export default __webpack_public_path__ + "static/char-54-anr-31cf9dda5bb4bb26c6998382b6230298.webp";